/**
 * @typedef {Object} DisputeHistoryOriginalBookingTimesCommentModelType
 * @property {string} startTime - Booking start time
 * @property {string} endTime - Booking end time
 * @property {number} breakMinutes - Amount of break minutes set on the booking
 */

/**
 * @class
 */
export default class DisputeHistoryOriginalBookingTimesCommentModel {
  /**
   * Create a new DisputeHistoryOriginalBookingTimesCommentModel.
   * @param {DisputeHistoryOriginalBookingTimesCommentModelType} params
   */
  constructor(params) {
    this.startTime = params.startTime
    this.endTime = params.endTime
    this.breakMinutes = params.breakMinutes
  }
}
